export default __webpack_public_path__ + "media/images/home-app-android-ee5f0ae8.png";